import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
// import App from './App';
import Routes from './routes/Routes';
// import reportWebVitals from './reportWebVitals';
import { StyleProvider, legacyLogicalPropertiesTransformer } from '@ant-design/cssinjs';
import { readLocalEnv } from '@dhbfront-utils/domain'
import * as Sentry from '@sentry/browser';


import { extractAppInfo } from './utils/utils';

if(process.env.NODE_ENV === 'production'){
  // Sentry.init({
  //   dsn: "https://187d95e64a1c468fbb051b4a5f079e6d@sentry2.dhb168.com/8",
  //   environment: window.location.host
  // });
}

extractAppInfo()

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <StyleProvider hashPriority="high" transformers={[legacyLogicalPropertiesTransformer]}>
    <Routes />
  </StyleProvider>
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals();
